export interface ResourceLink {
  name: string
  label: string
  urls: string[]
  urlDomains?: { url: string; domain: string }[]
}

export enum SocialLinkType {
  Explorers = 'Explorers',
  Markets = 'Markets',
  Whitepaper = 'Whitepaper',
  Website = 'Website',
  Sourcecode = 'Sourcecode',
  Disclosure = 'Sustainability Disclosure',
}

export type MarketPair = {
  exchange_id: number
  exchange_name: string
  exchange_slug: string
  exchange_website_url: string
  exchange_icon_url: string
  market_id: number
  market_pair_name: string
  quote_usd_price: number
  quote_usd_volume_24h: number
  depth_usd_positive_two: number
  depth_usd_negative_two: number
  isSticky?: boolean
  update_time: string
  formatted_amount?: string
}
